import { PreviewModal } from './preview-modal'

export default PreviewModal
